import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";
import { SettingsTabRedirect } from "../settings-tab-redirect";

export const inventorySettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Inventory management");
      },
      permission: settingsPagePermission(
        "inventory-management/inventory-management",
      ),
    },
    path: "inventory-management",
    lazy: async () => {
      const { InventoryManagementSettingsPage } =
        await import("../../../../setting/inventory-management/inventory-management-settings");
      return { Component: InventoryManagementSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("General", {
          context:
            "merchant settings label for general inventory configuration",
        });
      },
      permission: settingsPagePermission("inventory-management/general"),
    },
    path: "inventory-management/general",
    element: (
      <SettingsTabRedirect
        from="/settings/inventory-management/general"
        section="general"
        to="/settings/inventory-management"
      />
    ),
  },
  {
    handle: {
      get breadcrumb() {
        return t("Purchase orders", {
          context: "merchant settings label for inventory purchase orders",
        });
      },
      permission: settingsPagePermission(
        "inventory-management/purchase-orders",
      ),
    },
    path: "inventory-management/purchase-orders",
    element: (
      <SettingsTabRedirect
        from="/settings/inventory-management/purchase-orders"
        section="purchase-orders"
        to="/settings/inventory-management"
      />
    ),
  },
  {
    handle: {
      get breadcrumb() {
        return t("Sales channels", {
          context: "merchant settings label for sales channel inventory sync",
        });
      },
      permission: settingsPagePermission("inventory-management/sales-channels"),
    },
    path: "inventory-management/sales-channels",
    element: (
      <SettingsTabRedirect
        from="/settings/inventory-management/sales-channels"
        section="sales-channels"
        to="/settings/inventory-management"
      />
    ),
  },
  {
    handle: {
      breadcrumb: "QuickBooks Online",
      permission: settingsPagePermission("inventory-management/accounting"),
    },
    path: "inventory-management/quickbooks",
    children: [
      {
        index: true,
        element: (
          <SettingsTabRedirect
            from="/settings/inventory-management/quickbooks"
            section="accounting"
            to="/settings/inventory-management"
          />
        ),
      },
      {
        handle: {
          get breadcrumb() {
            return t("{{integrationName}} account mappings", {
              integrationName: "QuickBooks",
              context:
                "merchant settings breadcrumb for mapping QuickBooks accounting accounts",
            });
          },
        },
        path: "account-mapping",
        lazy: async () => {
          const { QuickBooksAccountMappingPage } =
            await import("../../../../setting/inventory-management/quickbooks-account-mapping");
          return { Component: QuickBooksAccountMappingPage };
        },
      },
    ],
  },
];
